import { ComponentPortal } from "@angular/cdk/portal";
import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Injector,
    Input,
    Output,
    ViewContainerRef,
    inject
} from "@angular/core";
import {
    InfoRecordComponent,
    RECORD_INFO_DATA
} from "@shared/components/info-record/info-record.component";
import { ICommentExtractor, InfoComment } from "@shared/types";
import { LocalCommentEditDialog } from "../local-comment-dialog/mod-local-comment-dialog.component";

@Component({
    selector: "local-comment-icon",
    templateUrl: "./local-comment-icon.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LocalCommentIconComponent {
    protected _localCommentEditDlgProvider = inject(LocalCommentEditDialog);
    private _container = inject(ViewContainerRef);
    @Input() current: InfoComment;
    @Input() convertor: ICommentExtractor;
    @Input() readOnly = false;

    @Input() isDisabled = false;

    @Output() readonly changed = new EventEmitter<string>();

    openLocalCommentDialog($event: Event) {
        $event.preventDefault();
        $event.stopPropagation();

        if (this.isDisabled) return;

        this._localCommentEditDlgProvider
            .open({
                id: this.convertor.getId(this.current),
                name: this.convertor.getSubject(this.current),
                comment: this.convertor.getComment(this.current),
                readOnly: this.readOnly,
                lastChangeDate:
                    this.current.local_comment_last_change_date ??
                    this.current.comment_last_change_date,
                lastChangeUserName:
                    this.current.local_comment_last_change_user_name ??
                    this.current.comment_last_change_user_name
            })
            .subscribe(comment => this.changed.next(comment));
    }

    getLocalCommentTooltip(row: InfoComment): ComponentPortal<unknown> | null {
        const comment = this.convertor.getComment(row);
        if (!comment) return null;
        const portalInjector = Injector.create({
            providers: [
                {
                    provide: RECORD_INFO_DATA,
                    useValue: {
                        name: comment,
                        text: null,
                        lastAuthor:
                            row.local_comment_last_change_user_name ??
                            row.comment_last_change_user_name,
                        lastChange:
                            row.local_comment_last_change_date ?? row.comment_last_change_date
                    }
                }
            ],
            parent: this._container.injector
        });
        return new ComponentPortal(InfoRecordComponent, null, portalInjector);
    }
}
